import { render, staticRenderFns } from "./Infinity.vue?vue&type=template&id=5775e230&scoped=true"
var script = {}
import style0 from "./Infinity.vue?vue&type=style&index=0&id=5775e230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5775e230",
  null
  
)

export default component.exports